import axios from 'axios'
import { getToken, removeToken } from './token'
import { getApplyId, getJobCode, getExpired, getIsInvite } from '@/utils/resumeParams'
import { Dialog, Toast } from 'vant'
import removeInfo from '@/utils/removeInfo'
import store from '@/store'
import router from '@/router'

// 防止并发 401 响应重复弹窗和覆盖 oldPhone
let isHandlingAuthExpired = false

const request = axios.create({
  // 设置超时时间
  timeout: 25000,
  // baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  baseURL: getBaseUrl(), // api的base_url
  responseType: 'json',
  headers: { 'Content-Type': 'application/json' }
  // validateStatus: status => {
  //     return status === 401 || status === 200; // default
  // },
})

function getBaseUrl () {
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_BASE_API
  } else if (process.env.NODE_ENV === 'production') {
    return window.location.origin + '/api'
  }
// 方明则接口： https://tszhaopin.greeyun.com/api/apply/userResume
}

// 添加请求拦截器
request.interceptors.request.use(
  config => {
    // 在请求发送前做些什么
    // 例如添加自定义请求头:
    // config.timeout = 10;
    if (config.url.includes('/v1/app/interview-room/') || config.url.includes('/v1/portal/') || config.url.includes('/deliver/v1/auth/wechat/')) {
      config.headers.token = store.state.applicant.applicantInfo.token
    }
    config.headers['X-ReqID'] = performance.now()
    if (getToken()) {
      config.headers.token = getToken()
    }
    console.log(config)
    return config
  },
  error => {
    // console.log(error);
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    if (response.data.code === 200 || response.data.code === 2001 || response.data.code === 3001 || response.data.code === 3010 || response.data.code === 403 || response.data.code === 601) {
      if (response.data.code === 601) {
        const { config } = response
        if (config.url.includes('/v2/social/resume/applican')) {
          Dialog.alert({
            title: '',
            message: '该职位已下线，请选择其他职位',
            confirmButtonText: '好的'
          }).then(() => {
            router.push('/jobList')
          })
          return Promise.reject(response.data.msg || response.data.message)
        }
      }
      return Promise.resolve(response.data)
    } else if (response.data.code === 201 || response.data.code === 202 || response.data.code === 203 || response.data.code === 204) {
      return Promise.reject(response.data.msg || response.data.message)
    } else if (response.data.code === 400 || response.data.code === 402 || response.data.code === 429) {
      return Promise.reject(response.data.message || response.data.msg)
    } else if (response.data.code === 40902) {
      Dialog.alert({
        title:'',
        message: '检测到应聘信息有变更，跳转至个人中心，请继续编辑',
      }).then(() => {
        // 跳转至个人中心
        router.push('/personal')
      })
      // return Promise.reject(response.data.message || response.data.msg || "检测到应聘信息有变更，跳转至个人中心，请继续编辑")
      return Promise.reject("检测到应聘信息有变更，跳转至个人中心，请继续编辑")
    }else if (response.data.code == 401 || response.data.code == 4003 || response.data.code === '401' || response.data.code === '4003') {
      // 客服等页面自行处理 401，跳过全局弹窗跳转
      if (response.config && response.config.skipGlobalAuth) {
        const err = new Error(response.data.message || '登录已过期')
        err.code = 401
        return Promise.reject(err)
      }
      // 保存旧手机号和当前页面路径，用于登录后判断是否回到原页面
      // 使用标志位防止并发 401 响应重复弹窗和覆盖 oldPhone
      if (!isHandlingAuthExpired) {
        isHandlingAuthExpired = true
        try {
          const applicantInfo = JSON.parse(sessionStorage.getItem('applicantInfo') || '{}')
          const currentPhone = sessionStorage.getItem('phone') || applicantInfo.phone || ''
          // 仅在能获取到手机号时才保存，避免 removeInfo 清除后用空值覆盖
          if (currentPhone) {
            sessionStorage.setItem('oldPhone', currentPhone)
          }
          // 保存当前 applyId 和 jobCode，登录后可恢复
          const savedApplyId = getApplyId()
          const savedJobCode = getJobCode()
          if (savedApplyId) sessionStorage.setItem('savedApplyId', savedApplyId)
          if (savedJobCode) sessionStorage.setItem('savedJobCode', savedJobCode)
          // 保存 expired 和 isInvite 标记，登录后可恢复标题显示
          const savedExpired = getExpired()
          const savedIsInvite = getIsInvite()
          if (savedExpired) sessionStorage.setItem('savedExpired', savedExpired)
          if (savedIsInvite) sessionStorage.setItem('savedIsInvite', savedIsInvite)
          // 不在登录页时才保存 loginRedirect，避免被登录后获取验证码等请求的 401 覆盖
          if (router.currentRoute.path !== '/login') {
            sessionStorage.setItem('loginRedirect', router.currentRoute.fullPath || '/')
          }
          console.log('[AuthExpired] 保存 oldPhone:', currentPhone, ', loginRedirect:', router.currentRoute.fullPath)
        } catch (e) {
          console.error('保存登录前状态失败:', e)
        }
        Dialog.alert({
          title: '登录过期',
          message: '请重新登录'
        })
          .then(async () => {
            try {
              removeInfo()
              const currentPath = window.location.hash.replace('#', '') || '/'
              router.push('/login?redirect=' + encodeURIComponent(currentPath))
            } catch (e) {
              Toast({ message: e, duration: 1500 })
            }
            isHandlingAuthExpired = false
          })
          .catch(() => {
            // on cancel
            isHandlingAuthExpired = false
          })
        return new Promise(() => {}) // 已弹窗提示，吞掉错误避免组件再弹 Toast
      }
      return Promise.reject(response.data.message)
    } else if (response.data.code === 500) {
      return Promise.reject(response.data.msg || response.data.message || '服务器或链接出现错误')
    } else {
      return Promise.reject(response.data.message || response.data.msg)
    }
  },
  error => {
    // console.log(error)
    // if (error.response) {
    //
    // }
    console.log(error)
    const httpStatus = error.response?.status
    const code = error.response?.data?.code
    // 同时检测 HTTP 状态码 401 与业务 code 401/4003
    const isUnauthorized = httpStatus === 401 || code === 401 || code === 4003
    if (isUnauthorized) {
      // 客服等页面自行处理 401，跳过全局弹窗跳转
      if (error.config && error.config.skipGlobalAuth) {
        const err = new Error(error.response?.data?.message || '登录已过期')
        err.code = 401
        return Promise.reject(err)
      }
      // 保存旧手机号和当前页面路径，用于登录后判断是否回到原页面
      // 使用标志位防止并发 401 响应重复弹窗和覆盖 oldPhone
      if (!isHandlingAuthExpired) {
        isHandlingAuthExpired = true
        try {
          const applicantInfo = JSON.parse(sessionStorage.getItem('applicantInfo') || '{}')
          const currentPhone = sessionStorage.getItem('phone') || applicantInfo.phone || ''
          // 仅在能获取到手机号时才保存，避免 removeInfo 清除后用空值覆盖
          if (currentPhone) {
            sessionStorage.setItem('oldPhone', currentPhone)
          }
          // 保存当前 applyId 和 jobCode，登录后可恢复
          const savedApplyId = getApplyId()
          const savedJobCode = getJobCode()
          if (savedApplyId) sessionStorage.setItem('savedApplyId', savedApplyId)
          if (savedJobCode) sessionStorage.setItem('savedJobCode', savedJobCode)
          // 保存 expired 和 isInvite 标记，登录后可恢复标题显示
          const savedExpired = getExpired()
          const savedIsInvite = getIsInvite()
          if (savedExpired) sessionStorage.setItem('savedExpired', savedExpired)
          if (savedIsInvite) sessionStorage.setItem('savedIsInvite', savedIsInvite)
          // 不在登录页时才保存 loginRedirect，避免被登录后获取验证码等请求的 401 覆盖
          if (router.currentRoute.path !== '/login') {
            sessionStorage.setItem('loginRedirect', router.currentRoute.fullPath || '/')
          }
          console.log('[AuthExpired] 保存 oldPhone:', currentPhone, ', loginRedirect:', router.currentRoute.fullPath)
        } catch (e) {
          console.error('保存登录前状态失败:', e)
        }
        Dialog.alert({
          title: '登录过期',
          message: '请重新登录'
        })
          .then(async () => {
            try {
              removeInfo()
              const currentPath = window.location.hash.replace('#', '') || '/'
              router.push('/login?redirect=' + encodeURIComponent(currentPath))
            } catch (e) {
              Toast({ message: e, duration: 1500 })
            }
            isHandlingAuthExpired = false
          })
          .catch(() => {
            // on cancel
            isHandlingAuthExpired = false
          })
        return new Promise(() => {}) // 已弹窗提示，吞掉错误避免组件再弹 Toast
      }
      return Promise.reject(error.response?.data?.message || '登录已过期')
    }
    return Promise.reject(error.response.data?.msg || '服务器或链接出现错误')
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject('网络开小差了，请稍后再试！')
  }
)

export default request
